import axios from "axios";
import { API } from "@/lib/content";

const TOKEN_KEY = "fr_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token);
  return data;
};

export const adminVerify = async () => {
  try {
    const { data } = await axios.get(`${API}/admin/verify`, { headers: authHeaders() });
    return data.valid;
  } catch {
    clearToken();
    return false;
  }
};

export const adminLogout = async () => {
  try {
    await axios.post(`${API}/admin/logout`, {}, { headers: authHeaders() });
  } catch {
    /* ignore */
  }
  clearToken();
};

export const adminSaveContent = async (hu, translate = true) => {
  const { data } = await axios.put(
    `${API}/admin/content`,
    { hu, translate },
    { headers: authHeaders(), timeout: 60000 }
  );
  return data;
};

export const adminReset = async () => {
  const { data } = await axios.post(`${API}/admin/reset`, {}, { headers: authHeaders() });
  return data;
};
